"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncActionImageLoad = void 0;
const pullstate_1 = require("pullstate");
async function loadImageFully(src) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = reject;
        img.src = src;
    });
}
exports.AsyncActionImageLoad = (0, pullstate_1.createAsyncAction)(async ({ src }) => {
    await loadImageFully(src);
    return (0, pullstate_1.successResult)();
});
